import * as React from "react";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useMemo } from "react";
import isFunction from "lodash/isFunction";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
const makeOptions = (options) => {
  const optionsSet = /* @__PURE__ */ new Set();
  const mappedOptions = options.map((option) => {
    if (typeof option === "string") {
      optionsSet.add(option);
      return { key: option, value: option };
    }
    const [key, value] = option;
    optionsSet.add(value);
    return { key, value };
  });
  return [mappedOptions, optionsSet];
};
const createEvent = (name, value) => ({
  target: { name, value }
});
const MultiSelectField = ({ name, field, title, error, value, onChange, values, inputHelp }) => {
  const { t } = useTranslation("aggregation");
  if (field.type !== "multi-select") {
    throw new Error("Invalid field type passed!");
  }
  const [selectOption, optionsSet] = useMemo(() => {
    if (isFunction(field.options)) return makeOptions(field.options({ formValues: values }));
    return makeOptions(field.options);
  }, [values, field]);
  const onSelect = useCallback(
    (newValue) => onChange(createEvent(name, newValue === "" ? [] : newValue.split(","))),
    [name, onChange]
  );
  const selectedValue = useMemo(() => value.join(","), [value]);
  useEffect(() => {
    const checkedValue = value.filter((option) => optionsSet.has(option)).join(",");
    if (selectedValue !== checkedValue) {
      onSelect(checkedValue);
    }
  }, [optionsSet, value, onSelect, selectedValue]);
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `${name}-select`,
      label: title,
      error,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      help: inputHelp
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        options: selectOption,
        name,
        value: selectedValue,
        multi: true,
        onChange: onSelect,
        "aria-label": t("wizard_visualization.select_field", { field: field.title }),
        displayKey: "key",
        inputId: "multi-select-visualization"
      }
    )
  );
};
export default MultiSelectField;
